





































































































































































































import {Getter, Action} from "vuex-class";
import Component from "vue-class-component";
import {
  SelectWings,
  ToggleWings,
  DatePickerWings,
  FastDateDetailWings,
  NumberWings,
} from 'wings-ui-components';
import {PropSync, Watch} from 'vue-property-decorator'
import Swal from "sweetalert2";
import {DetailFilterParams} from "@/store/user_management/action_users/types";
import {beginningOfCurrentDay, currentDateEnd, dateFilter} from "@/utils/date-util";
import {notifyError, notifyWarning} from "@/utils/notify-helper";
import BaseFilter from "@/components/Filter/BaseFilter";
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({
  components: {
    NumberWings,
    SelectWings,
    ToggleWings,
    DatePickerWings,
    FastDateDetailWings,
  },
  filters: {dateFilter}
})
export default class ActionUsersFilter extends BaseFilter<DetailFilterParams> {
  @PropSync('filterProp') filterParent!: any;
  @PropSync('runFilter') run!: any;
  @PropSync('show') is_show!: boolean;

  @Getter("systemPages") systemPagesList: any;
  @Getter("partnerUsersPages") partnerPagesList: any;
  @Getter("objectTypes") objectTypesList: any;
  @Getter("systemUsersAction") systemUsersActionList: any;

  @Action("exportActionUsers") actionExportActionUsers: any;
  @Action("getPartnerUsers") actionGetPartnerUsers: any;
  @Action("getSystemUsers") actionGetSystemUsers: any;
  @Action("getSystemPages") actionGetSystemPages: any;
  @Action("getPartnerUsersPages") actionGetPartnerPages: any;
  @Action("getSystemUsersAction") actionSystemUsersAction: any;
  @Action("getObjectTypes") actionGetObjectTypes: any;
  @Action("getActionUsers") getActionUsers: any;
  @Action("getSystemActions") getSystemActions: any;

  private localLang: string = 'ru';
  filterKeys: object = {
    "action_status": "status"
  }
  partnerUsersList: any = [];
  systemUsersList: any = [];

  defaultFilter(): DetailFilterParams {
    return {
      date_from: beginningOfCurrentDay(),
      date_to: currentDateEnd(),
      action_user: null,
      action_page: null,
      action_source: null,
      object_type: null,
      object_name: null,
      action: null,
      action_status: null,
      page_number: 1,
    }
  }

  async getSystemUsersList(filter: any) {
    const items = await this.actionGetSystemUsers(filter);
    this.systemUsersList = (filter?.page_number > 1) ? this.systemUsersList.concat(items) : items
  }

  async getPartnerUsersList(filter: any) {
    const items = await this.actionGetPartnerUsers({email: filter.query, page_number: filter.page_number});
    this.partnerUsersList = (filter?.page_number > 1) ? this.partnerUsersList.concat(items) : items
  }

  async created() {
    this.actionGetObjectTypes();
    this.actionGetSystemPages();
    this.actionGetPartnerPages();
    this.actionSystemUsersAction();

    this.localLang = this.$i18n.locale;
    if (this.filter.action_user && this.filter.action_source === 'admin') {
      this.systemUsersList = await this.actionGetSystemUsers({email: this.filter.action_user});
    }
    if (this.filter.action_user && this.filter.action_source === 'lk') {
      this.partnerUsersList = await this.actionGetPartnerUsers({email: this.filter.action_user});
    }
    this.scroll();
  }

  async onFilteredAction(nextPage = false) {
    if (!nextPage) this.filter.page_number = 1;
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "User action",
        addititional_info: getTranslatedParams(this.filter, this.filterKeys)
      }
      const resp = await this.getActionUsers(this.filter);
      await this.actionLog(this.logObject);
      if (resp.data.actions.length == 0) {
        this.is_last = true
        if (!nextPage) notifyWarning()
      } else {
        this.is_last = false
      }
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    } finally {
      this.moreLoading = false;
    }
  }

  exportActionUsers(): void {
    this.logObject = {
      action_page: this.$route.meta.msgKey,
      action: "Export",
      action_status: "success",
      object_type: "User action",
      addititional_info: getTranslatedParams(this.filter, this.filterKeys)
    }
    this.actionExportActionUsers(this.sendFilter).then((res: any) => {
      this.actionLog(this.logObject);
      if (res.data && res.data.status == "Success") {
        Swal.fire({
          type: 'success',
          title:<string> this.$t('success'),
          confirmButtonClass: "md-button md-success",
          html:<string> this.$t('dialog.export'),
          showConfirmButton: true
        });
      } else {
        Swal.fire({
          type: 'error',
          title: <string> this.$t('error'),
          confirmButtonClass: "md-button md-danger",
          html: <string> this.$t('dialog.error_export'),
          showConfirmButton: true
        });
      }
    }).catch(()=> this.actionLog({...this.logObject, action_status: "failed"}));
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChanged(val: DetailFilterParams) {
    this.filterParent = val;
  }

  @Watch('run')
  onRunFilter(val: boolean) {
    if (!val) return;
    this.filtered();
    this.run = false;
  }

  @Watch('filter.action_source', {immediate: false, deep: true})
  onChangeActionSource(old_val: any, new_val: any) {
    if (old_val !== new_val) {
      this.filter.action_user = null;
      this.filter.action_page = null;
      this.filter.action = null;
    }
  }

  get getPagesList() {
    return this.filter.action_source === 'admin' ? this.systemPagesList : this.partnerPagesList
  }

  get usersActionList() {
    return this.systemUsersActionList.filter((action: any) => action.action_source === this.filter.action_source || action.action_source === 'all');
  }

  get getLangField() {
    return this.localLang === 'ru' ? 'rus_name' : 'eng_name'
  }

  getSourceName(name: any):any {
    return this.getPagesList.find((item: any) => item.name === name)?.[this.getLangField]
  }

  getObjectTypeLabel(name: string): string {
    return this.objectTypesList.find((e: any) => e.eng_name === name)?.[this.getLangField];
  }

  getSystemActionsLabel(name: string): string {
    return this.systemUsersActionList.find((e: any) => e.eng_name === name)?.[this.getLangField];
  }
}
